import { create } from 'zustand'
import camelcaseKeys from 'camelcase-keys'
import { supabase } from '../supabaseClient'

export interface ChannelState {
  // The ENABLED channels, for the channel pickers.
  channels: Channel[]
  // EVERY channel, with its floor, for the floor mark (app#361). ⚠ Disabled ones are needed too:
  // a node on a disabled channel stays on it in the router (`db.EffectiveChannel`), and the floor
  // holds it whether the channel is enabled or not (`Channel.HoldsBelowFloor`).
  allChannels: Channel[]
  get: () => Promise<void>
  subscribe: () => () => void
  reset: () => void
}

const state = {
  channels: [] as Channel[],
  allChannels: [] as Channel[],
}

const useChannel = create<ChannelState>()((set) => ({
  ...state,
  get: async () => {
    const { data, error } = await supabase
      .from('channels')
      .select('id, name, enabled, is_default, min_version')
      .order('name')

    if (error) console.warn(error)
    else {
      const allChannels = data.map(row => camelcaseKeys(row)) as Channel[]
      set({ allChannels, channels: allChannels.filter(channel => channel.enabled) })
    }
  },
  subscribe: () => () => {}, // No realtime needed — channels are static config
  reset: () => set({ ...state }),
}))

export default useChannel
